<template>
  <div>
    <site-plan-component></site-plan-component>
  </div>
</template>

<script setup lang="ts">
import SitePlanComponent from './components/SitePlanComponent.vue';

</script>

<style lang="scss">
body.modal-open {
  overflow: hidden;
}

#app {
  font-family: Roboto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #131E29;
}

@font-face {
  font-family: 'Gilroy-SemiBold';
  font-weight: 600;
  src: url('./assets/fonts/Gilroy-SemiBold.ttf');
}

@font-face {
  font-family: 'Argent-Light';
  src: url('./assets/fonts/Argent-Light.ttf');
}
</style>
